import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { Layout } from './components/Layout';
import { GoalYetBot } from './pages/GoalYetBot';
import { Dashboard } from './pages/Dashboard';
import { Projects } from './pages/Projects';
import { Users } from './pages/Users';
import { Files } from './pages/Files';
import { API } from './pages/API';
import { GoalTracker } from './components/GoalTracker';
import { GoalYet } from './pages/GoalYet';
import { ChecklistDemo } from './pages/ChecklistDemo';
import BuildDashboard from './pages/BuildDashboard';
import ChangelogPage from './pages/ChangelogPage';
import { LandingPage } from './pages/LandingPage';
import { NextSteps } from './pages/NextSteps';
import { AuthForm } from './components/AuthForm';
import { AIIntegrationDebugger } from './components/AIIntegrationDebugger';
import { AIGoalAnalyzer } from './components/AIGoalAnalyzer';
import { DebugTools } from './pages/DebugTools';
import { GoalsHistory } from './pages/GoalsHistory';

function App() {
  const { token } = useAuth();

  if (!token) {
    return <LandingPage />;
  }

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<GoalYet />} />
        <Route path="assistant" element={<AIGoalAnalyzer />} />
        <Route path="goalyet" element={<GoalYet />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="goals" element={<GoalTracker />} />
        <Route path="goals-history" element={<GoalsHistory />} />
        <Route path="projects" element={<Projects />} />
        <Route path="users" element={<Users />} />
        <Route path="files" element={<Files />} />
        <Route path="api" element={<API />} />
        <Route path="checklists" element={<ChecklistDemo />} />
        <Route path="build" element={<BuildDashboard />} />
        <Route path="changelog" element={<ChangelogPage />} />
        <Route path="next" element={<NextSteps />} />
        <Route path="ai-debug" element={<AIIntegrationDebugger />} />
        <Route path="debug" element={<DebugTools />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default App;
